<template>
  <div class="sideblock-container">
    <div
      v-for="block in sideBlocksByRegion(region)"
      :key="block.id"
      :class="[
        'block',
        'block--sideblock',
        {
          'block--hasimage': block.image?.path,
          'block--imageonly': block.image?.path && !block.content
        }
      ]"
    >
      <a :href="block.url">
        <div
          v-if="block.content"
          class="block--sideblock_content"
          v-html="block.content"
        />
        <img
          v-if="block.image?.path"
          :src="block.image.path"
          :alt="block.image.alt || ''"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps<{ region: string }>();
  const pageContentStore = usePageContentStore();

  const sideBlocksByRegion = (region: string) =>
    pageContentStore.getSideBlocksByRegion(region);
</script>

<style lang="scss" scoped>
  .block--sideblock {
    color: $pfgreen;

    a {
      text-decoration: none;
      color: $pfgreen;
    }
  }

  .block--hasimage {
    padding: 0;
    position: relative;

    &:not(.block--imageonly) {
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      }

      .block--sideblock_content {
        padding: 30px;
      }
    }
  }

  .block--sideblock_content {
    display: block;
    position: relative;
    z-index: 20;

    :deep(*) {
      font-size: 1.2rem;
    }

    :deep(h2) {
      font-size: 1.7rem;
      font-weight: bold;
    }

    :deep(h3) {
      font-size: 1.6rem;
      font-weight: bold;
    }

    :deep(h4) {
      font-size: 1.5rem;
      font-weight: bold;
    }

    :deep(h5) {
      font-size: 1.4rem;
      font-weight: bold;
    }

    :deep(p) {
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
</style>
